import spacetime from 'spacetime';

export const isDryJan = () => {
    const DRY_JAN_START = spacetime([2024, 11, 1]);
    const DRY_JAN_END = spacetime([2025, 0, 7]);

    return spacetime.now().isBetween(DRY_JAN_START, DRY_JAN_END);
};
